<template>
  <div style="padding: 0 1px;">
    <a-page-header
      class="page-header"
      :ghost="false"
      style="margin-bottom: 16px"
    >
      <template #title>
        <a-space size="middle">
          <a-icon type="alert"></a-icon>
          <span>历史告警</span>
        </a-space>
      </template>
      <span>历史告警包含名称、严重性、触发时间等。</span>
    </a-page-header>

    <a-tabs v-model="activeTab" :animated="false">
      <a-tab-pane key="overview" tab="总览">
        <a-row :gutter="16">
          <alert-statistic></alert-statistic>

          <a-col :sm="24" :md="12" :lg="16" style="margin-bottom: 16px">
            <a-card :bordered="false" :body-style="{padding: '12px 16px', height: '328px'}">
              <div class="module-header-fs14">告警趋势图</div>
              <alert-trend></alert-trend>
            </a-card>
          </a-col>

          <a-col :sm="24" :md="12" :lg="8" style="margin-bottom: 16px">
            <a-card :bordered="false" :body-style="{padding: '12px 16px', height: '328px'}">
              <div class="module-header-fs14">告警处理率</div>
              <processing-rate></processing-rate>
            </a-card>
          </a-col>

          <a-col :sm="24" :md="12" :lg="8" style="margin-bottom: 16px">
            <a-card :bordered="false" :body-style="{padding: '12px 16px', height: '294px'}">
              <div class="module-header-fs14">业务告警TOP 5</div>
              <service-top></service-top>
            </a-card>
          </a-col>

          <a-col :sm="24" :md="12" :lg="8" style="margin-bottom: 16px">
            <a-card :bordered="false" :body-style="{padding: '12px 16px', height: '294px'}">
              <div class="module-header-fs14">处室告警TOP 5</div>
              <department-top></department-top>
            </a-card>
          </a-col>

          <a-col :sm="24" :md="12" :lg="8" style="margin-bottom: 16px">
            <a-card :bordered="false" :body-style="{padding: '12px 16px', height: '294px'}">
              <div class="module-header-fs14">告警信息TOP 5</div>
              <alert-name-top></alert-name-top>
            </a-card>
          </a-col>
        </a-row>
      </a-tab-pane>
      <a-tab-pane key="list" tab="列表详情">
        <a-card :bordered="false" style="margin-bottom: 16px">
          <list-layout
            :column-default-selected="columnDefaultSelected"
            :columns-all="columnsAll"
            :export-func="exportFunc"
            :get-table-data-func="getTableDataFunc"
            :refresh="refresh"
            :table-operation-width="200"
            :customer-params="params"
            :tools-list="['setting', 'reload', 'search', 'leftTool', 'export']"
            :defaultSelected="tableSelectData"
            @tableSelectData="(v) => tableSelectData = v"
            :can-drag-column-width="true"
            :search-type-options="[
              { label: '告警内容', value: 'name' },
              { label: 'IP 地址', value: 'monitor_address' }
            ]"
          >
            <!-- 工具栏 -->
            <template #leftTool>
              <datetime-range
                @ok="
                  v => {
                    datetimeRange = v
                  }
                "
              ></datetime-range>
            </template>
            <!-- 表格自定义列 -->
            <template #name="{ slotProps }">
              <a-tooltip placement="topLeft" :title="slotProps.text">
                <a @click="$refs.detailDrawer.show(slotProps.record.id)">
                  {{ slotProps.text }}
                </a>
              </a-tooltip>
            </template>
            <template #severity="{ slotProps }">
              <alert-severity-tag :severity="slotProps.text"></alert-severity-tag>
            </template>
            <template #sourceType="{ slotProps }">
              {{ $t(`source_type.${slotProps.text}`) }}
            </template>
            <template #source="{ slotProps }">
              <a-tooltip placement="topLeft" :title="slotProps.text?.name">
                <a @click="click(slotProps.record.source_type, slotProps.text?.id)">
                  {{ slotProps.text?.name }}
                </a>
              </a-tooltip>
            </template>
            <template #duration="{ slotProps }">
              {{ duration(slotProps.record.triggered_at, slotProps.record.recovered_at) }}
            </template>
            <template #recovered="{ slotProps }">
              <boolean-tag
                :value="slotProps.text"
                false-name="未恢复"
                true-name="已恢复"
              ></boolean-tag>
            </template>

            <template #ticketState="{ slotProps }">
              <ticket-status-tag :status="slotProps.text" display-type="text" :font-size="14"></ticket-status-tag>
            </template>
            <template #operation="{ slotProps }">
              <create-ticket-button
                v-if="!slotProps.record.ticket_id && slotProps.record.ticket_state !== 'closed'"
                @click="createTicket(slotProps.record.id)"
              ></create-ticket-button>
              <jump-to-ticket-button
                v-if="slotProps.record.ticket_id && slotProps.record.ticket_state !== 'closed'"
                @click="jumpToTicket(slotProps.record)"
              ></jump-to-ticket-button>
              <delete-button v-permission="{action: 'base.alert.delete', effect: 'disabled'}" @confirm="confirm(slotProps.record.id)"></delete-button>
            </template>
          </list-layout>
        </a-card>
      </a-tab-pane>
    </a-tabs>

    <alert-drawer ref="detailDrawer"></alert-drawer>
    <network-device-drawer ref="networkDeviceDrawer"></network-device-drawer>
    <storage-drawer ref="storageDrawer"></storage-drawer>
    <server-drawer ref="serverDrawer"></server-drawer>
    <os-drawer ref="osDrawer"></os-drawer>
    <middleware-drawer ref="middlewareDrawer"></middleware-drawer>
    <database-drawer ref="databaseDrawer"></database-drawer>
    <application-drawer ref="applicationDrawer"></application-drawer>
    <site-drawer ref="siteDrawer"></site-drawer>
    <containerization-drawer ref="containerizationDrawer" :containerization-type="containerizationType"></containerization-drawer>
  </div>
</template>

<script>
import storage from 'store'
import { mapGetters } from 'vuex'
import { deleteAlert, exportAlert, getAlertList } from '@/api/alert'
import { getContainerization } from '@/api/containerization'
import { createAlertITSM } from '@/api/itsm'
import { humanAlertDuration } from '@/utils'
import { alertSeverities, sourceTypes, ticketStates } from '@/utils/const'

import AlertDrawer from '@/components/drawer/AlertDrawer/index.vue'
import AlertNameTop from './modules/AlertNameTop.vue'
import AlertSeverityTag from '@/components/tag/AlertSeverityTag'
import AlertStatistic from './modules/AlertStatistic.vue'
import AlertTrend from './modules/AlertTrend.vue'
import BooleanTag from '@/components/tag/BooleanTag'
import CreateTicketButton from '@/components/button/CreateTicketButton.vue'
import DatetimeRange from '@/components/DatetimeRange'
import DeleteButton from '@/components/button/DeleteButton'
import DepartmentTop from './modules/DepartmentTop.vue'
import JumpToTicketButton from '@/components/button/JumpToTicketButton.vue'
import ListLayout from '@/components/ListLayout'
import ProcessingRate from './modules/ProcessingRate.vue'
import ServiceTop from './modules/ServiceTop.vue'
import TicketStatusTag from '@/components/tag/TicketStatusTag.vue'

export default {
  name: 'AlertHistory',
  components: {
    AlertDrawer,
    AlertNameTop,
    AlertSeverityTag,
    AlertStatistic,
    AlertTrend,
    ApplicationDrawer: () => import('@/components/drawer/ApplicationDrawer'),
    BooleanTag,
    ContainerizationDrawer: () => import('@/components/drawer/ContainerizationDrawer'),
    CreateTicketButton,
    DatabaseDrawer: () => import('@/components/drawer/DatabaseDrawer'),
    DatetimeRange,
    DeleteButton,
    DepartmentTop,
    JumpToTicketButton,
    ListLayout,
    MiddlewareDrawer: () => import('@/components/drawer/MiddlewareDrawer'),
    NetworkDeviceDrawer: () => import('@/components/drawer/NetworkDeviceDrawer'),
    'os-drawer': () => import('@/components/drawer/OSDrawer'),
    ProcessingRate,
    ServerDrawer: () => import('@/components/drawer/ServerDrawer'),
    ServiceTop,
    SiteDrawer: () => import('@/components/drawer/SiteDrawer'),
    StorageDrawer: () => import('@/components/drawer/StorageDrawer'),
    TicketStatusTag
  },
  data () {
    return {
      exportFunc: exportAlert,
      getTableDataFunc: getAlertList,
      activeTab: this.$route.params.activeTab || 'overview',
      columnsAll: [
        {
          dataIndex: 'service_name',
          title: '业务系统',
          fixed: 'left',
          width: 200,
          ellipsis: true,
          scopedSlots: {
            customRender: 'service_name'
          }
        },
        {
          dataIndex: 'name',
          title: '告警内容',
          fixed: 'left',
          width: 300,
          ellipsis: true,
          scopedSlots: {
            customRender: 'name'
          }
        },
        {
          dataIndex: 'source_ip',
          title: 'IP',
          fixed: 'left',
          width: 150,
          ellipsis: true,
          scopedSlots: {
            customRender: 'source_ip'
          }
        },
        {
          dataIndex: 'severity',
          title: '严重性',
          width: 90,
          scopedSlots: {
            customRender: 'severity'
          },
          filteredValue: [],
          filters: alertSeverities.map(value => {
            return {
              text: this.$t(`alert_severity.${value}`),
              value
            }
          }),
          filterMultiple: false
        },
        {
          dataIndex: 'source_type',
          title: '资源类型',
          width: 140,
          scopedSlots: {
            customRender: 'sourceType'
          },
          filteredValue: [],
          filters: sourceTypes.map(value => {
            return {
              text: this.$t(`source_type.${value}`),
              value
            }
          }),
          filterMultiple: false
        },
        {
          dataIndex: 'source',
          title: '资源名称',
          width: 200,
          ellipsis: true,
          scopedSlots: {
            customRender: 'source'
          }
        },
        {
          dataIndex: 'triggered_at',
          title: '触发时间',
          width: 200,
          scopedSlots: {
            customRender: 'triggeredAt'
          }
        },
        {
          dataIndex: 'recovered_at',
          title: '恢复时间',
          width: 200,
          scopedSlots: {
            customRender: 'recoveredAt'
          }
        },
        {
          dataIndex: 'duration',
          title: '持续时间',
          width: 150,
          ellipsis: true,
          scopedSlots: {
            customRender: 'duration'
          }
        },
        {
          dataIndex: 'recovered',
          title: '告警状态',
          width: 120,
          scopedSlots: {
            customRender: 'recovered'
          },
          filteredValue: [],
          filters: [
            {
              text: '已恢复',
              value: 'true'
            },
            {
              text: '未恢复',
              value: 'false'
            }
          ],
          filterMultiple: false
        },
        {
          dataIndex: 'created_at',
          title: '创建时间',
          width: 200
        },
        {
          dataIndex: 'updated_at',
          title: '更新时间',
          width: 200
        },
        {
          dataIndex: 'ticket_state',
          title: '工单状态',
          width: 120,
          scopedSlots: {
            customRender: 'ticketState'
          },
          filteredValue: [],
          filters: ticketStates.map(value => {
            return {
              text: this.$t(`ticket_status.${value}`),
              value
            }
          }),
          filterMultiple: false
        },
        {
          dataIndex: 'ticket_processor',
          title: '工单负责人',
          width: 160,
          scopedSlots: {
            customRender: 'ticketProcessor'
          }
        },
        {
          dataIndex: 'ticket_created_at',
          title: '工单创建时间',
          width: 180,
          scopedSlots: {
            customRender: 'ticketCreatedAt'
          }
        }
      ],
      columnDefaultSelected: [
        'service_name',
        'name',
        'source_ip',
        'severity',
        'source_type',
        'source',
        'triggered_at',
        'recovered',
        'ticket_state',
        'ticket_processor'
      ],
      refresh: false,
      datetimeRange: [],
      customerParams: this.$route.params,
      tableSelectData: [],
      containerizationType: ''
    }
  },
  computed: {
    params () {
      const obj = {}
      for (const key in this.customerParams) {
        if (Object.hasOwnProperty.call(this.customerParams, key)) {
          obj[key] = this.customerParams[key]
        }
      }
      if (this.datetimeRange.length) {
        obj.datetime_from = this.datetimeRange[0].format('YYYY-MM-DD HH:mm')
        obj.datetime_to = this.datetimeRange[1].format('YYYY-MM-DD HH:mm')
      }
      return obj
    },
    ...mapGetters(['opsItsmApi'])
  },
  mounted () {
    const params = this.$route.params
    if (params.source_type) {
      this.columnsAll.filter(column => {
        if (column.dataIndex === 'source_type') {
          column.filteredValue = [params.source_type]
        }
      })
    }
    if (params.recovered) {
      this.columnsAll.filter(column => {
        if (column.dataIndex === 'recovered') {
          column.filteredValue = [params.recovered]
        }
      })
    }
    if (params.severity) {
      this.columnsAll.filter(column => {
        if (column.dataIndex === 'severity') {
          column.filteredValue = [params.severity]
        }
      })
    }
  },
  methods: {
    duration (triggeredAt, recoveredAt) {
      return humanAlertDuration(triggeredAt, recoveredAt)
    },
    createTicket (id) {
      createAlertITSM({ alert_id: id }).then(res => {
        this.$message.success(res.message)
        this.refresh = !this.refresh
      })
    },
    jumpToTicket (alert) {
      let urlKey = ''
      let secret = ''
      const items = storage.get('ACCESS_TOKEN').split('.')
      if (items.length === 3) {
        urlKey = items[1]
        secret = items[2]
      }
      window.open(
        `${this.opsItsmApi}/auth/sso?key=${urlKey}&secret=${secret}&redirect=/process/handle-ticket&workOrderId=${alert.ticket_id}&processId=2`,
        // `http://localhost:9527/auth/sso?key=${urlKey}&secret=${secret}&redirect=/process/handle-ticket&workOrderId=${alert.ticket_id}&processId=40`,
        '_blank'
      )
    },
    async confirm (id = '') {
      if (id) {
        await deleteAlert(id).then(res => {
          this.$message.success(res.message)
        })
        this.tableSelectData.splice(this.tableSelectData.findIndex(item => item.key === id), 1)
      }
      this.refresh = !this.refresh
    },
    click (sourceType, sourceId) {
      switch (sourceType) {
        case 'network_device':
          this.$refs.networkDeviceDrawer.show(sourceId)
          break
        case 'storage':
          this.$refs.storageDrawer.show(sourceId)
          break
        case 'server':
          this.$refs.serverDrawer.show(sourceId)
          break
        case 'os':
          this.$refs.osDrawer.show(sourceId)
          break
        case 'middleware':
          this.$refs.middlewareDrawer.show(sourceId)
          break
        case 'database':
          this.$refs.databaseDrawer.show(sourceId)
          break
        case 'application':
          this.$refs.applicationDrawer.show(sourceId)
          break
        case 'containerization':
          // 要先获取containerization_type
          getContainerization(sourceId).then(res => {
            this.containerizationType = res.data.containerization_type
            this.$refs.containerizationDrawer.show(sourceId)
          })
          break
        case 'site':
          this.$refs.siteDrawer.show(sourceId)
          break
      }
    }
  }
}
</script>
